export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/makers_experience_perseus/apps/buyer-step-1.14113f7.svg";